import React, {useState} from 'react';

import NavBarAdmin from './NavBarAdmin';
import MenuDrawer from './MenuDrawer';
import {makeStyles} from '@material-ui/core';


const useStyle = makeStyles(theme =>({
  root : {
    display : 'flex'
  },
  content : {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down('sm')] : {
      padding : theme.spacing(1)
      }
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  offset :  {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
})); 

const AdminLayout = (props) => {
  const classes = useStyle()
  const [open, setopen] = useState(false);  
  
  return (
      <div className={classes.root} >
        
          <NavBarAdmin   open={open} setopen={setopen}/>
          <MenuDrawer  open={open} setopen={setopen}/>
              <div className ={classes.content}>
              <div className={classes.offset}></div>
                {props.children}
              </div>
            

      </div>
      
    );
}
 
export default AdminLayout;